import { Modal, Tag } from "antd";
import React, { useMemo } from "react";
import { formatDate } from "../../../../../js/helpers/formatDates";
import { getUniqueFilters } from "../../../../../js/helpers/getUniqueFilters";
import DateTable from "../../../../controls/DateTable";

export const HistoryModal = ({
  visible,
  onCancel,
  productHistory,
  loading,
  productSelected
}) => {
  const transformedData = productHistory.map((item) => ({
    ...item,
    usuario: item.usuarioDTO?.nombre || item.usuarioDTO?.nick || "N/A",
    fecha: formatDate(item.fecha),
  }));

  const usuarioFilters = useMemo(
    () => getUniqueFilters(transformedData, "usuario"),
    [transformedData]
  );
  const accionFilters = useMemo(
    () => getUniqueFilters(transformedData, "accion"),
    [transformedData]
  );

  const getAccionTag = (accion) => {
    const color =
      accion === "Sumar" ? "green" : accion === "Actualizar conteo" ? "gold" : "blue";
    return <Tag color={color}>{accion}</Tag>;
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "fecha",
      key: "fecha",
      render: (text) => formatDate(text),
      search: true,
    },
    {
      title: "Acción",
      dataIndex: "accion",
      key: "accion",
      filters: accionFilters,
      onFilter: (value, record) => record.accion === value,
      render: (text) => getAccionTag(text),
    },
    {
      title: "Cantidad",
      dataIndex: "cantidadIgresada",
      key: "cantidadIgresada",
      search: true,
    },
    {
      title: "Usuario",
      dataIndex: "usuario",
      key: "usuario",
      filters: usuarioFilters,
      onFilter: (value, record) => record.usuario === value,
    },
  ];

  return (
    <Modal
      title={`Historial del Producto${productSelected ? ` - ${productSelected.productoSucursal}` : ""}`}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <DateTable data={transformedData} columns={columns} loading={loading} />
    </Modal>
  );
};
